function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Document, elsterDocxUtils } from './utils/elster_docx_utils';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { createElements } from './create_elements';
import generateFootersSetting from './settings/generateFootersSetting';
import generateHeadersSetting from './settings/generateHeadersSetting';
import generateDocumentProperties from './settings/generateDocumentProperties';
import { mainTextStyles, smallTextStyles } from './styles/elsterDocStyles';
export const generateElsterDocument = async _ref => {
  let {
    data,
    user
  } = _ref;
  const locale = (user === null || user === void 0 ? void 0 : user.local_language) || 'en';
  const elsterVersion = (data === null || data === void 0 ? void 0 : data.elster_version) || 'version_7';
  const fileNameDate = createTimezonedDate(new Date()).toCustomLocaleDateString(true);
  const {
    createDocument
  } = elsterDocxUtils;
  const getDocumentName = () => {
    return "".concat(fileNameDate, "_").concat(data.company_name.replace(' ', '_').toLowerCase(), "_elster_document_").concat(data.elster_financial_year, "_").concat(user.first_name.toLowerCase(), "_").concat(locale, "_").concat(elsterVersion);
  };

  // Create the document
  const doc = new Document({
    styles: {
      paragraphStyles: [{
        id: 'mainText',
        name: 'mainText',
        basedOn: 'Normal',
        next: 'Normal',
        quickFormat: true,
        run: _objectSpread({}, mainTextStyles)
      }, {
        id: 'small_text',
        name: 'small_text',
        basedOn: 'Normal',
        next: 'Normal',
        quickFormat: true,
        run: _objectSpread({}, smallTextStyles)
      }]
    },
    sections: [{
      properties: generateDocumentProperties(),
      headers: generateHeadersSetting(),
      footers: generateFootersSetting(),
      children: createElements(data, user, elsterVersion)
    }]
  });
  createDocument(getDocumentName(), doc);
};